// Скрываем куки сразу при загрузке
document.documentElement.style.setProperty('--tinycookie-display', 'none');

document.addEventListener('DOMContentLoaded', function() {
  const isHomepage = window.location.pathname === '/';
  const hasSeenPreloader = sessionStorage.getItem('homepage-preloader-seen');
  
  if (isHomepage && !hasSeenPreloader) {
    showPreloader();
    sessionStorage.setItem('homepage-preloader-seen', 'true');
  } else {
    // Если preloader не показывается, показываем куки через 2 сек
    setTimeout(() => {
      showCookie();
    }, 2000);
  }
  
  // При клике на лого или home link
  document.querySelectorAll('a[href="/"], a[href="' + window.location.origin + '"]').forEach(link => {
    link.addEventListener('click', function(e) {
      if (window.location.pathname !== '/') {
        sessionStorage.removeItem('homepage-preloader-seen');
      }
    });
  });
  
  function showPreloader() {
    const preloader = document.getElementById('homepage-preloader');
    if (preloader) {
      setTimeout(() => {
        preloader.classList.add('hide');
        // Показываем куки через 0.5 сек после preloader
        setTimeout(() => {
          showCookie();
        }, 500);
      }, 2800);
    }
  }
  
  function showCookie() {
    const cookie = document.getElementById('TinyCookie');
    if (cookie) {
      cookie.style.opacity = '0';
      cookie.style.display = 'block';
      setTimeout(() => {
        cookie.style.transition = 'opacity 0.3s ease';
        cookie.style.opacity = '1';
      }, 50);
    }
  }
});
